/**
 * @description Регулярное выражение удаляющая номер телефона
 * @type {RegExp}
 */
const REGEXP_DELETE_PHONE_NUMBER = /\s*\+?\s*[78]?\s*\(?\d{3}\)?\s*\d{3}[- ]?\d{2}[- ]?\d{2}\s*$/;

/**
 * @description Примись поиска пациента
 * @type {any}
 */
export default {
  methods: {
    /**
     * @description Подготовить запрос.
     * @param {string|null} newValue
     * @param {string} oldValue
     * @returns {string|null}
     */
    prepareQuery(newValue, oldValue) {
      if (newValue === null) {
        return '';
      }
      const newQuery = newValue
        .replace(REGEXP_DELETE_PHONE_NUMBER, '')
        .replace(/^\s+/, '');
      if (oldValue || oldValue === '') {
        const oldQuery = oldValue
          .replace(REGEXP_DELETE_PHONE_NUMBER, '')
          .replace(/^\s+/, '');
        if (oldQuery === newQuery) {
          return null;
        }
      }
      return newQuery;
    },
  },
};
